export enum CurrencySymbol {
    usd = '$',
}
